import { render, staticRenderFns } from "./ClientsAccountDetails.vue?vue&type=template&id=1a1adf00&scoped=true&"
import script from "./ClientsAccountDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientsAccountDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1adf00",
  null
  
)

export default component.exports